import type { BatchState } from 'models/batches';
import { BATCHES_STATUS } from 'models/batches';

export const BATCHES_TABLE_TEST_ID = 'batches-table-id';
export const BATCHES_TITLE_TEST_ID = 'batches-header-title';
export const BATCHES_DETAILS_TEST_ID = 'batches-details-id';

export const BATCHES_STATUS_FILTER_TEST_ID = 'batches-status-filters';

export const BATCHES_STATUSES: Array<BatchState> = [
  {
    id: 'waiting_review',
    value: BATCHES_STATUS.WAITING_REVIEW,
    order: 1,
    label: 'Pending approval',
    style: {
      color: 'bg-status-pending',
      activeColor: 'bg-status-pending-active',
      hover: 'hover:bg-status-pending-active'
    }
  },
  {
    id: 'rejected',
    value: BATCHES_STATUS.REJECTED,
    order: 2,
    label: 'Declined',
    style: {
      color: 'bg-status-negative',
      activeColor: 'bg-status-negative-active',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: 'completed',
    value: BATCHES_STATUS.COMPLETED,
    order: 3,
    label: 'Approved',
    style: {
      color: 'bg-status-completed',
      activeColor: 'bg-status-completed-active',
      hover: 'hover:bg-status-completed-active'
    }
  }
];
